/**
 * Created by fengc on 2020/04/02.
 */
import React from "react";
import PropTypes from "prop-types";
import Syllable from "./Syllable";
import MessageBox from "./MessageBox";
import UIDs from "../../UIDs";
import { withTranslation } from "react-i18next";
import { pinyin } from "pinyin-pro";
import _ from "lodash";

const uid = UIDs.components.ui.letter;

class Letter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showInput: false,
            syllables: this.props.data.pinyin || "",
			oldSyllables: this.props.data.pinyin || "",
			data: this.props.data
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.data !== state.data) {
            return {
				syllables: props.data.pinyin || "",
				oldSyllables: props.data.pinyin || "",
				data: props.data
			};
        }
        return null;
    }

	render() {
	    let isPolyphonic = false;
	    if(this.props.data.char){
	        let arr = pinyin(this.props.data.char, { multiple: true, type: "array" });
	        if(_.isArray(arr)){
	            isPolyphonic = arr.length>1;
	        }
	    }

		let containerStyle = styles.container;
		if (this.props.style) {
			containerStyle = { ...containerStyle, ...this.props.style };
		}

		let contentStyle = styles.content;

		let letterStyle = styles.letter;
		let pinyinStyle = styles.pinyin;

		if (this.props.style.fontSize) {
			const { fontSize } = this.props.style;
			letterStyle = { ...styles.letter, fontSize: fontSize };

			// calculate the pinyin size based on fontsize
			let pinyinFontSize = parseFloat(fontSize);
			if (isNaN(pinyinFontSize)) {
				pinyinFontSize = parseFloat(fontSize.substring(0, fontSize.length - 2));
			}
			pinyinFontSize = pinyinFontSize * 0.5;
			pinyinStyle = { ...styles.pinyin, fontSize: pinyinFontSize };
		}
		let syllableWidth = this.state.syllables.length * 10 < 22 ? 22 : this.state.syllables.length * 10;
		return (
			<div style={containerStyle} onClick={this.props.onClick}>
				{this.props.pinyinVisible && (
					<div style={{ ...styles.pinyinContainer, ...contentStyle }}>
						<div style={pinyinStyle}
						    onClick={this._handleSyllableClicked.bind(this)}
						>{(this.props.data.pinyin || this.props.data.pinyin === "") ?
						    <>
						        {this.props.onSyllableChange ?
						            this.state.showInput ?
						                <input type="text" defaultValue={this.state.syllables} maxLength="7"
                                            style={{border:"0", backgroundColor: isPolyphonic ? "#FF8C00" : "#0096cc", fontSize:"14px", width: syllableWidth, textAlign:"center", borderRadius:3, color:"#fff", padding:"0px 4px 1px"}}
                                            onChange={this._handleSyllableChanged}
                                            onBlur={this._handleSyllableBlur.bind()}
                                            onKeyDown={this._handleKeyDown}
                                            autoFocus={true}
                                        />
                                    :  this.props.data.pinyin === " " ? null : <Syllable data={this.state.syllables} style={{backgroundColor: isPolyphonic ? "#FFD700" : "#cceaf5", borderRadius:3, padding:"0px 4px 1px", fontSize:"14px"}} />
                                :
                                    <Syllable data={this.state.syllables} />
                                }
						    </>
						: <span>&nbsp;</span>}</div>
					</div>
				)}
				{this.props.charVisible && (
					<div style={contentStyle}>
						<div style={letterStyle}>{this.props.data.char}</div>
					</div>
				)}
			</div>
		);
	}
	_handleClicked = () => {
		if (this.props.onClick) {
			this.props.onClick(this.props.data);
		}
	};

    //修改拼音
	_handleSyllableClicked = () =>{
	    // var re = /^[a-zü1-4]+$/i;
	    // if (this.state.syllables === "" || re.test(this.state.syllables)){
	    //     this.setState({
        //         showInput: true,
        //     })
	    // }

		//we allow you edit it no matter what the value is
		this.setState({
                showInput: true,
            })
	}

    _handleSyllableChanged = (event) => {
        event.stopPropagation();
        var val = event.target.value;
        this.setState({
            syllables: val,
        });
    }

    _handleSyllableBlur = () =>{
        var val = this.state.syllables;
        var re = /^[a-zü1-4]+$/i;

        if(val === ""){
            this.setState({
                showInput:false,
                // syllables: this.state.oldSyllables,
            });
            // MessageBox.danger({ text: this.props.t("fieldIsRequired"), duration: 5000 });
            // return false;
        }else{
            if (!re.test(val))
            {
                this.setState({
                    showInput:false,
                    syllables: this.state.oldSyllables,
                });
                MessageBox.danger({ text: this.props.t("pinyinErrFormat"), duration: 5000 });
                return false;
            }else{
                let str = val.slice(-2);
                var isNum = /^\d+$/.test(str);
                if(isNum){
                    this.setState({
                        showInput:false,
                        syllables: this.state.oldSyllables,
                    });
                    MessageBox.danger({ text: this.props.t("pinyinErrFormat"), duration: 5000 });
                    return false;
                }

                this.setState({
                    showInput:false,
                });
            }
        }

        let retData = {
            sentenceIndex: this.props.data.sentenceIndex,
            wordIndex: this.props.data.wordIndex,
            letterIndex: this.props.data.letterIndex,
            syllables: this.state.syllables,
        }
        if (this.props.onSyllableChange) {
            this.props.onSyllableChange(retData);
        }
    }

    _handleKeyDown = (event) =>{
        var evt = window.event || event;
        evt.stopPropagation();
        if (evt.keyCode === 13) {
            this._handleSyllableBlur();
            evt.preventDefault();
        }
    }
}

const styles = {
	container: { margin: "5px 1px 2px" },
	content: {},
	pinyinContainer: {
		//height: "1.2em" //support empty pinyin case  //苹果上显示太高了，用了下面的lineHeight设置
		lineHeight:1.5,
	},
	pinyin: {
		fontSize: 8,
		textAlign: "center",
	},
	letter: {
		fontSize: 16,
		lineHeight:1.2,
		textAlign: "center",
	}
};

Letter.propTypes = {
	data: PropTypes.object,
	style: PropTypes.object,
	onClick: PropTypes.func,
	charVisible: PropTypes.bool,
	pinyinVisible: PropTypes.bool,
};

Letter.defaultProps = {
	data: {
		pinyin: "",
		char: "",
	},
	style: {}, // this one will be applied on container style
	onClick: null,
	charVisible: true, // if show Chinese character
	pinyinVisible: true, // if show piyin of chinese character
};

export default withTranslation(uid)(Letter);
